import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home.vue'
import SigninOidc from '@/views/auth/signin-oidc.vue';
import SigninOidcSilent from '@/views/auth/signin-oidc-silent.vue';
import SignoutOidc from '@/views/auth/signout-oidc.vue';
import Dashboard from "@/views/dashboard.vue";
import ListCounts from "@/views/list-counts.vue";
import ServeMeals from "@/views/serve-meals.vue";
import Offline from "@/views/offline.vue";
import PrivacyPolicy from "@/views/legal/privacy-policy.vue";
import TermsOfUse from "@/views/legal/terms-of-use.vue";
import { routePaths } from './routePaths';

import store from '@/store';

Vue.use(VueRouter);

export class TestRoutes {
  paths = {
    home: { path: '/tests/test-home', name: 'tests/home' },
    countWizard: {
      mcClicker: { path: '/tests/count-wizard/mc-clicker', name: 'tests/count-wizard/mc-clicker' },
      mcMealWizard: { path: '/tests/count-wizard/mc-meal-wizard', name: 'tests/count-wizard/mc-meal-wizard' },
      mcReceive: { path: '/tests/count-wizard/mc-receive', name: 'tests/count-wizard/mc-receive' },
      mcServe: { path: '/tests/count-wizard/mc-serve', name: 'tests/count-wizard/mc-serve' },
      mcSummary: { path: '/tests/count-wizard/mc-summary', name: 'tets/count-wizard/mc-summary' },
      mcTally: { path: '/tests/count-wizard/mc-tally', name:'tests/count-wizard/mc-tally' },
      mcWaste: { path: '/tests/count-wizard/mc-waste', name: 'tests/count-wizard/mc-waste' }
    },
    addressCard: { path: '/tests/address-card', name: 'tests/address-card' },
    mcCountStatusButton: { path: '/tests/mc-count-status-button', name: 'tests/mc-count-status-button' },
    mcFooter: { path: '/tests/mc-footer', name: 'tests/mc-footer' },
    mcHeader: { path: '/tests/mc-header', name: 'tests/mc-header' },
    mcMealCard: { path: '/tests/mc-meal-card', name: 'tests/mc-meal-card' },
    mcSync: { path: '/tests/mc-sync', name: 'tests/mc-sync' },
    mcToast: { path: '/tests/mc-toast', name: 'tests/mc-toast' },
    sponsorSiteInfo: { path: '/tests/sponsor-site-info', name: 'tests/sponsor-site-info' }
  }

  private _routes = [
    {
      path: this.paths.home.path,
      name: this.paths.home.name,
      component: () => import('@/tests/test-home.vue'),
      meta: {
        displayName: 'Test Home',
        showNav: false
      },
      children: [
        {
          path: this.paths.countWizard.mcClicker.path,
          name: this.paths.countWizard.mcClicker.name,
          component: () => import('@/tests/count-wizard/mc-clicker.tests.vue'),
          meta: {
            displayName: 'count-wizard/mc-clicker',
            showNav: true
          }
        },
        {
          path: this.paths.countWizard.mcMealWizard.path + '/:siteId/:sponsorId/:programId/:date/:mealType/:type',
          name: this.paths.countWizard.mcMealWizard.name,
          component: () => import('@/tests/count-wizard/mc-meal-wizard.tests.vue'),
          meta: {
            displayName: 'count-wizard/mc-meal-wizard',
            showNav: true
          }
        },
        {
          path: this.paths.countWizard.mcReceive.path,
          name: this.paths.countWizard.mcReceive.name,
          component: () => import('@/tests/count-wizard/mc-receive.tests.vue'),
          meta: {
            displayName: 'count-wizard/mc-receive',
            showNav: true
          }
        },
        {
          path: this.paths.countWizard.mcServe.path,
          name: this.paths.countWizard.mcServe.name,
          component: () => import('@/tests/count-wizard/mc-serve.tests.vue'),
          meta: {
            displayName: 'count-wizard/mc-serve',
            showNav: true
          }
        },
        {
          path: this.paths.countWizard.mcSummary.path,
          name: this.paths.countWizard.mcSummary.name,
          component: () => import('@/tests/count-wizard/mc-summary.tests.vue'),
          meta: {
            displayName: 'count-wizard/mc-summary',
            showNav: true
          }
        },
        {
          path: this.paths.countWizard.mcTally.path,
          name: this.paths.countWizard.mcTally.name,
          component: () => import('@/tests/count-wizard/mc-tally.tests.vue'),
          meta: {
            displayName: 'count-wizard/mc-tally',
            showNav: true
          }
        },
        {
          path: this.paths.countWizard.mcWaste.path,
          name: this.paths.countWizard.mcWaste.name,
          component: () => import('@/tests/count-wizard/mc-waste.tests.vue'),
          meta: {
            displayName: 'count-wizard/mc-waste',
            showNav: true
          }
        },
        {
          path: this.paths.addressCard.path,
          name: this.paths.addressCard.name,
          component: () => import('@/tests/address-card.tests.vue'),
          meta: {
            displayName: 'address-card',
            showNav: true
          }
        },
        {
          path: this.paths.mcCountStatusButton.path,
          name: this.paths.mcCountStatusButton.name,
          component: () => import('@/tests/mc-count-status-button.tests.vue'),
          meta: {
            displayName: 'mc-count-status-button',
            showNav: true
          }
        },
        {
          path: this.paths.mcFooter.path,
          name: this.paths.mcFooter.name,
          component: () => import('@/tests/mc-footer.tests.vue'),
          meta: {
            displayName: 'mc-footer',
            showNav: true
          }
        },
        {
          path: this.paths.mcHeader.path,
          name: this.paths.mcHeader.name,
          component: () => import('@/tests/mc-header.tests.vue'),
          meta: {
            displayName: 'mc-header',
            showNav: true
          }
        },
        {
          path: this.paths.mcMealCard.path,
          name: this.paths.mcMealCard.name,
          component: () => import('@/tests/mc-meal-card.tests.vue'),
          meta: {
            displayName: 'mc-meal-card',
            showNav: true
          }
        },
        {
          path: this.paths.mcSync.path,
          name: this.paths.mcSync.name,
          component: () => import('@/tests/mc-sync.tests.vue'),
          meta: {
            displayName: 'mc-sync',
            showNav: true
          }
        },
        {
          path: this.paths.mcToast.path,
          name: this.paths.mcToast.name,
          component: () => import('@/tests/mc-toast.tests.vue'),
          meta: {
            displayName: 'mc-toast',
            showNav: true
          }
        },
        {
          path: this.paths.sponsorSiteInfo.path,
          name: this.paths.sponsorSiteInfo.name,
          component: () => import('@/tests/sponsor-site-info.tests.vue'),
          meta: {
            displayName: 'sponsor-site-info',
            showNav: true
          }
        }
      ]
    }
  ]

  get routes() {
    let result: any[] = [];
    if (process.env.NODE_ENV === 'development') {
      result = this._routes;
    }
    return result;
  }

  get navRoutes() {
    let result: any[] = [];

    const routes = this.routes;
    if (routes.length > 0) {
      result = routes[0].children.filter(r => r.meta.showNav);
    }

    return result;
  }
}

export const testRoutes = new TestRoutes();


export class DemoRoutes {
  paths = {
    home: { path: '/demo/demo-home', name: 'demo/home' },
    countStatuses: { path: '/demo/count-statuses', name: 'demo/count-statuses' }
  }

  private _routes = [
    {
      path: this.paths.home.path,
      name: this.paths.home.name,
      component: () => import('@/views/demo/demo-home.vue'),
      meta: {
        displayName: 'Demo Home',
        showNav: false
      },
      children: [
        {
          path: this.paths.countStatuses.path,
          name: this.paths.countStatuses.name,
          component: () => import('@/views/demo/count-statuses.vue'),
          meta: {
            displayName: 'Count Statuses',
            showNav: true
          }
        }
      ]
    }
  ]

  get routes() {
    let result: any[] = [];
    if (process.env.NODE_ENV === 'development') {
      result = this._routes;
    }
    return result;
  }

  get navRoutes() {
    let result: any[] = [];

    const routes = this.routes;
    if (routes.length > 0) {
      result = routes[0].children.filter(r => r.meta.showNav);
    }

    return result;
  }
}

export const demoRoutes = new DemoRoutes();

const appRoutes = [
  {
    path: routePaths.home.path,
    name: routePaths.home.name,
    component: Home
  },
  {
    path: '/signin-oidc',
    name: 'signin-oidc',
    component: SigninOidc
  },
  {
    path: '/signin-oidc-silent',
    name: 'signin-oidc-silent',
    component: SigninOidcSilent
  },
  {
    path: '/signout-oidc',
    name: 'signout-oidc',
    component: SignoutOidc
  },
  {
    path: routePaths.dashboard.path,
    name: routePaths.dashboard.name,
    component: Dashboard,
    meta: {
      auth: true,
      requireCache: true
    }
  },
  {
    path: routePaths.listCounts.path,
    name: routePaths.listCounts.name,
    component: ListCounts,
    meta: {
      auth: true,
      requireCache: true
    }
  },
  {
    path: routePaths.serveMeals.path + '/:siteId/:sponsorId/:programId/:date/:mealType/:type',
    name: routePaths.serveMeals.name,
    component: ServeMeals,
    meta: {
      auth: true,
      requireCache: true
    }
  },
  {
    path: routePaths.offline.path,
    name: routePaths.offline.name,
    component: Offline,
    meta: {
      auth: false,
      requireCache: true
    }
  },
  {
    path: routePaths.termsOfUse.path,
    name: routePaths.termsOfUse.name,
    component: TermsOfUse,
    meta: {
      auth: false,
      requireCache: false
    }
  },
  {
    path: routePaths.privacyPolicy.path,
    name: routePaths.privacyPolicy.name,
    component: PrivacyPolicy,
    meta: {
      auth: false,
      requireCache: false
    }
  }
];

const routes = [
  ...appRoutes,
  ...demoRoutes.routes,
  ...testRoutes.routes
];

const router = new VueRouter({
  routes,
  // mode: 'history'
});

router.beforeEach((to, from, next) => {
  if (!to.meta?.auth) {
    return next();
  }
  // First, check if the route requires auth of any kind
  let routeRequiresAuth = to.meta.auth;
  if (routeRequiresAuth) {
    const isAuth = store.state.auth.isAuthenticated;

    if (isAuth) {
      return next();
    }
    return next(routePaths.home.path);
  }
});

export default router;
export * from './routePaths';
